import React from 'react'
import { IPropsTickets, ISellCreditTicket } from '../utils/interfaceTickets'
import { setearMiles } from 'util/funciones'

const InfoProduct = ({ data }: IPropsTickets) => {

    let newData = data as ISellCreditTicket   

    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th className="receipt__table__header" style={{ width: '50%' }}></th>
                        <th className="receipt__table__header" style={{ width: '50%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="receipt__table__cell">PRODUCTOS</td>
                        <td className="receipt__table__cell text__ellipsis w__ellipsis__medium">{newData.producto}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">PRECIO</td>
                        <td className="receipt__table__cell">${setearMiles(newData.precio)}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">CANTIDAD</td>
                        <td className="receipt__table__cell">{setearMiles(newData.cantidad, 3)} GL</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">DESCUENTO</td>
                        <td className="receipt__table__cell">${setearMiles(newData.descuento)}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell">TOTAL</td>
                        <td className="receipt__table__cell">${setearMiles(newData.valor_venta_total)}</td>
                    </tr>
                    <tr>
                        <td className="receipt__table__cell" colSpan={2}>{newData.valor_venta_texto} PESOS</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default InfoProduct